import {CompanyAddress} from '../../models';
import {makeAsyncReducer, StateAsyncProperty} from '../../redux-toolbelt';

import {getCompanyAddresses} from './companyAddressesActions';

export type CompanyAddressesState = StateAsyncProperty<CompanyAddress[]>;

export default makeAsyncReducer<CompanyAddressesState>(getCompanyAddresses);
